import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

import Field from '../../util/field/Field';
import Select from 'react-select';


const SCHEMA = Yup.object({
    tasaImpuestoId: Yup.object().required("El campo 'Tasa de impuesto' es requerido.").nullable(),
    listaPreciosId: Yup.object().required("El campo 'Lista de Precio' es requerido.").test(
        "validate_sin_asignacion", 
        "Agregue una asignación valida para 'Lista de Precio'.", (value) => value && value.Description != "Pendiente Asignación").nullable(),
    menuId: Yup.object().required("El campo 'Menu' es requerido.").test(
        "validate_sin_asignacion_menu", 
        "Agregue una asignación valida para 'Menu'.", (value) => value && value.Description != "Pendiente Asignación").nullable(),
    plazaId: Yup.object().required("El campo 'Plaza' es requerido.").nullable(),
});

/**
 * Formulario con la información general del folio
 */
export const StepFacturacionDrive = ({ ...props }) => {    
    const [puntoVenta, setPuntoVenta]  = useState({
        tasaImpuestoId: null,
        listaPreciosId: null,
        menuId: null,
        plazaId:null
    });

    useEffect(() => {
        let pdv = {...props.caffenio}        

        pdv.tasaImpuestoId = props.TasaImp.find(val => val.TaxRateId == pdv.tasaImpuestoId);
        pdv.listaPreciosId = props.listasPrecio.find(val => val.PriceListId == pdv.listaPreciosId);
        pdv.menuId = props.menus.find(val => val.MenuId == pdv.menuId);
        pdv.plazaId = props.plazas.find(val => val.idPlaza == pdv.plazaId);
        
        
        setPuntoVenta(pdv);
        
    }, [])

    const mapValues= (values)=>{
        let caffenioUpdated = {...values};
        caffenioUpdated.tasaImpuestoId = values.tasaImpuestoId ? values.tasaImpuestoId.value : null;  
        caffenioUpdated.listaPreciosId = values.listaPreciosId ? values.listaPreciosId.value : null;  
        caffenioUpdated.menuId = values.menuId ? values.menuId.value : null;  
        caffenioUpdated.plazaId = values.plazaId ? values.plazaId.value : null;
        
        return caffenioUpdated;

    }
    return (
        <Formik
            enableReinitialize={true}
            initialValues={puntoVenta}
            validationSchema={SCHEMA}
            onSubmit={(values) => {
                let caffenioUpdated = mapValues(values);
                props.save(caffenioUpdated)
            }}>
            {({ values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched }) => (
                <form onSubmit={handleSubmit} id="frmFacturacionDriveStep">
                    <div className="columns is-multiline">
                        
                        <div className="column is-12">
                            <Field label="Tasa Impuesto" isHorizontal
                                hasError={errors.tasaImpuestoId }
                                msgError={errors.tasaImpuestoId && touched.tasaImpuestoId ? errors.tasaImpuestoId : ""}>
                                    <div className="column is-12">
                                    <Select
                                        placeholder={"Seleccionar..."}
                                        name={"tasaImpuestoId"}
                                        value={values.tasaImpuestoId}
                                        onChange={(val) => {
                                            setFieldValue('tasaImpuestoId', val)
                                            
                                            }}
                                        noOptionsMessage={() => "No hay opciones"}
                                        options={props.TasaImp}
                                        isClearable 
                                        disabled={true}/>

                                    </div>
                                    
                            </Field>
                        </div>

                        <div className="column is-12">
                            <Field label="Lista de precio" isHorizontal
                                hasError={errors.listaPreciosId}
                                msgError={errors.listaPreciosId && touched.listaPreciosId ? errors.listaPreciosId : ""}>
                                
                                <div className="column is-12">
                                    <Select
                                        placeholder={"Seleccionar..."}
                                        name={"listaPreciosId"}
                                        value={values.listaPreciosId}
                                        onChange={(val) => {setFieldValue('listaPreciosId', val)}}
                                        noOptionsMessage={() => "No hay opciones"}
                                        options={props.listasPrecio}
                                        isClearable 
                                        />
                                </div>
                            </Field>
                        </div>

                        <div className="column is-12">
                            <Field label="Menu" isHorizontal
                                hasError={errors.menuId}
                                msgError={errors.menuId && touched.menuId ? errors.menuId : ""}>
                                
                                <div className="column is-12">
                                    <Select
                                        placeholder={"Seleccionar..."}
                                        name={"menuId"}
                                        value={values.menuId}
                                        onChange={(val) => {setFieldValue('menuId', val)}}
                                        noOptionsMessage={() => "No hay opciones"}
                                        options={props.menus}
                                        isClearable 
                                        />
                                </div>
                            </Field>
                        </div>

                        <div className="column is-12">
                            <Field label="Plaza" isHorizontal
                                hasError={errors.plazaId}
                                msgError={errors.plazaId && touched.plazaId ? errors.plazaId : ""}>
                                
                                <div className="column is-12">
                                    <Select
                                        placeholder={"Seleccionar..."}
                                        name={"plazaId"}
                                        value={values.plazaId}
                                        onChange={(val) => {setFieldValue('plazaId', val)}}
                                        noOptionsMessage={() => "No hay opciones"}
                                        options={props.plazas}
                                        isClearable 
                                        />
                                </div>
                            </Field>
                        </div>
                    </div>
                    <br />
                    <div className="has-text-left buttons-modal" id="stepActions">
                        <div className="pull-left">
                            <button id="btnBackStepFacturacionDrive" type="button" className="button is-light" onClick={() => {                                
                                props.back({...props.caffenio})}} >Anterior</button>

                        </div>
                    </div>
                    <div className="has-text-right buttons-modal" id="stepActions">
                        <div className="pull-right">
                            <button id="btnSaveStepFacturacionDrive" type="submit" className="button is-light" style={{marginRight:"5px"}}   >Guardar y Continuar</button>
                        
                            <button id="btnNextStepFacturacionDrive" type="button" className="button is-success" onClick={() =>props.nextWithoutSave(mapValues(values))} >Siguiente</button>
                        </div>
                            
                        
                    </div>

                </form>
            )}

        </Formik>
    );

}

export default StepFacturacionDrive;